import RemoveProfile from './RemoveProfile';

export default RemoveProfile;
